import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_SubstanceAbuseDischarge = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_SubstanceAbuseDischarge' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>STATE OF FLORIDA</h3></p>
                <p className='w-750'><h3>SUBSTANCE ABUSE & MENTAL HEALTH</h3></p>
                <p className='w-750'><h3>SUBSTANCE ABUSE DISCHARGE FORM</h3></p>
                <p className='w-750'><b>Page 6B- 4</b></p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>1. *CONTRACTOR IDENTIFIER:</span><span className='small'>593128476</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>2. *SITE IDENTIFIER:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>5. *RESIDENT COUNTY:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtConractor' name='txtConractor' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSiteIdentifier' name='txtSiteIdentifier' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtClientSsn' name='txtClientSsn' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>6. *HIGHEST EDUCATION:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu' id='chkHighestEdu' className='add-only' value='1' />00 - No Schooling
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu2' id='chkHighestEdu2' className='add-only' value='1' />01 - Grade 1
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu3' id='chkHighestEdu3' className='add-only' value='1' />30 - Associate's Degree (AA, AS, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu4' id='chkHighestEdu4' className='add-only' value='1' />02 - Grade 2
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu5' id='chkHighestEdu5' className='add-only' value='1' />03 - Grade 3
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu6' id='chkHighestEdu6' className='add-only' value='1' />31 - Bachelor's Degree (BA, BS, AB, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu7' id='chkHighestEdu7' className='add-only' value='1' />04 - Grade 4
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu8' id='chkHighestEdu8' className='add-only' value='1' />05 - Grade 5
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu9' id='chkHighestEdu9' className='add-only' value='1' />32 - Master's Degree (MS, MA, MSW, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu10' id='chkHighestEdu10' className='add-only' value='1' />06 - Grade 6
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu11' id='chkHighestEdu11' className='add-only' value='1' />07 - Grade 7
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu12' id='chkHighestEdu12' className='add-only' value='1' />33 - Professional Degree (MD, DDS, JD, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu13' id='chkHighestEdu13' className='add-only' value='1' />08 - Grade 8
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu14' id='chkHighestEdu14' className='add-only' value='1' />24 - Grade 9
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu15' id='chkHighestEdu15' className='add-only' value='1' />34 - Doctorate Degree (PhD, EDD, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu16' id='chkHighestEdu16' className='add-only' value='1' />25 - Grade 10
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu17' id='chkHighestEdu17' className='add-only' value='1' />26 - Grade 11
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu18' id='chkHighestEdu18' className='add-only' value='1' />35 - Special School
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu19' id='chkHighestEdu19' className='add-only' value='1' />27 - Grade 12
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu20' id='chkHighestEdu20' className='add-only' value='1' />36 - Vocational School
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu21' id='chkHighestEdu21' className='add-only' value='1' />28 - High School Graduate, Diploma/GED
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkHighestEdu23' id='chkHighestEdu23' className='add-only' value='1' />38 - College Undergraduate Freshman (2nd Year)
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu22' id='chkHighestEdu22' className='add-only' value='1' />37 - College Undergraduate Freshman (1st Year)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkHighestEdu24' id='chkHighestEdu24' className='add-only' value='1' />39 - College Undergraduate Freshman (3rd Year)
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHighestEdu25' id='chkHighestEdu25' className='add-only' value='1' />40 - College Undergraduate Freshman (4th Year)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHighestEdu26' id='chkHighestEdu26' className='add-only' value='1' />41 - Kindergarten
                        </td>
                        <td className='w-550'>
                            <input type='checkbox' name='chkHighestEdu27' id='chkHighestEdu27' className='add-only' value='1' />42 - Nursery School/Preschool/Head Start
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7. *MARITAL STATUS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus' id='chkMerritalStatus' className='add-only' value='1' />1 - Single
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus1' id='chkMerritalStatus1' className='add-only' value='1' />2 - Married
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkMerritalStatus2' id='chkMerritalStatus2' className='add-only' value='1' />5 - Separated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus3' id='chkMerritalStatus3' className='add-only' value='1' />6 - Unreported
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus4' id='chkMerritalStatus4' className='add-only' value='1' />3 - Widowed
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkMerritalStatus5' id='chkMerritalStatus5' className='add-only' value='1' />7 - Registered Domestic Partner
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus6' id='chkMerritalStatus6' className='add-only' value='1' />4 - Divorced
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkMerritalStatus7' id='chkMerritalStatus7' className='add-only' value='1' />8 - Legally Separated
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>8. *HEALTH STATUS (HIPAA):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus' id='chkHealthStatus' className='add-only' value='1' />1 - Agitated
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus1' id='chkHealthStatus1' className='add-only' value='1' />4 - Depressed
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHealthStatus2' id='chkHealthStatus2' className='add-only' value='1' />7 - Other Mental Condition
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus3' id='chkHealthStatus3' className='add-only' value='1' />2 - Comatose
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus4' id='chkHealthStatus4' className='add-only' value='1' />5 - Forgetful
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkHealthStatus5' id='chkHealthStatus5' className='add-only' value='1' />8 - Oriented
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus6' id='chkHealthStatus6' className='add-only' value='1' />3 - Disoriented
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkHealthStatus7' id='chkHealthStatus7' className='add-only' value='1' />6 - Lethargic
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>9. *PREGNANCY TRIMESTER:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkPregnancyStatus' id='chkPregnancyStatus' className='add-only' value='1' />1 - 1-3 Months
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkPregnancyStatus1' id='chkPregnancyStatus1' className='add-only' value='1' />3 - 7-9 Months
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkPregnancyStatus2' id='chkPregnancyStatus2' className='add-only' value='1' />5 - Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkPregnancyStatus3' id='chkPregnancyStatus3' className='add-only' value='1' />2 - 4-6 Months
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkPregnancyStatus4' id='chkPregnancyStatus4' className='add-only' value='1' />4 - Not Pregnant or male
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>

                
                <p className='w-750'><b>Page 6B- 5</b></p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>10. *ADMISSION TYPE:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' name='chkAdmissionStatus' id='chkAdmissionStatus' className='add-only' value='1' />1 - Voluntary Competent
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' name='chkAdmissionStatus1' id='chkAdmissionStatus1' className='add-only' value='1' />2 - Voluntary Incompetent
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdmissionStatus2' id='chkAdmissionStatus2' className='add-only' value='1' />3 - Involuntary Competent
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='chkAdmissionStatus3' id='chkAdmissionStatus3' className='add-only' value='1' />4 - Involuntary Incompetent
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>11. *DRUG COURT ORDERED:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbEnglish_Yes' name='rbEnglish' className='add-only' value='1' /> 0-No
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbEnglish_No' name='rbEnglish' className='add-only' value='2' /> 1-Yes
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>12. *INVOLVED IN CHILD WELFARE:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbEnglish1_Yes' name='rbEnglish1' className='add-only' value='1' /> 0-No
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbEnglish1_No' name='rbEnglish1' className='add-only' value='2' /> 1-Yes
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>13. *RESIDENTIAL STATUS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus' id='chkResidentalStatus' className='add-only' value='1' />01 - Independent Living-alone
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus1' id='chkResidentalStatus1' className='add-only' value='1' />10 - State MH Treatment Facility (State Hospital)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus2' id='chkResidentalStatus2' className='add-only' value='1' />02 - Independent Living-with Relatives
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus3' id='chkResidentalStatus3' className='add-only' value='1' />11 - Nursing Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus4' id='chkResidentalStatus4' className='add-only' value='1' />03 - Independent Living-with Non-Relatives
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus5' id='chkResidentalStatus5' className='add-only' value='1' />12 - Supported Housing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus6' id='chkResidentalStatus6' className='add-only' value='1' />04 - Dependent Living-with Relatives
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus7' id='chkResidentalStatus7' className='add-only' value='1' />13 - Correctional Facility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus8' id='chkResidentalStatus8' className='add-only' value='1' />05 - Dependent Living-with Non-Relatives
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus9' id='chkResidentalStatus9' className='add-only' value='1' />14 - DJJ Facility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus10' id='chkResidentalStatus10' className='add-only' value='1' />06 - Assisted Living Facility (ALF)
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus11' id='chkResidentalStatus11' className='add-only' value='1' />15 - Crisis Residence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus12' id='chkResidentalStatus12' className='add-only' value='1' />07 - Foster Care/Home
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus13' id='chkResidentalStatus13' className='add-only' value='1' />16 - Children Residential Treatment Facility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus14' id='chkResidentalStatus14' className='add-only' value='1' />08 - Adult Residential Treatment Facility (Group Home)
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus15' id='chkResidentalStatus15' className='add-only' value='1' />17 - Limited Mental Health Licensed ALF
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus16' id='chkResidentalStatus16' className='add-only' value='1' />09 - Homeless
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkResidentalStatus17' id='chkResidentalStatus17' className='add-only' value='1' />18 - Other Residential Status
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkResidentalStatus18' id='chkResidentalStatus18' className='add-only' value='1' />99 - Not Available or Unknown
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>14. *DEPENDENCY/CRIMINAL STATUS:</span></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated' id='chkAdjudicated' className='add-only' value='1' />00 - Insufficient Information
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Adjudicated Children:</b></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated31' id='chkAdjudicated31' className='add-only' value='1' />01 - Delinquent, in physical custody
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated30' id='chkAdjudicated30' className='add-only' value='1' />02 - Delinquent, not in physical custody
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated29' id='chkAdjudicated29' className='add-only' value='1' />03 - Dependent, in physical custody
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated28' id='chkAdjudicated28' className='add-only' value='1' />04 - Dependent, not in physical custody
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated27' id='chkAdjudicated27' className='add-only' value='1' />05 - Dependent & Delinquent, in physical custody
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated26' id='chkAdjudicated26' className='add-only' value='1' />06 - Dependent & Delinquent, not in physical custody
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated25' id='chkAdjudicated25' className='add-only' value='1' />07 - 'Children in Need of services' (CINS), not in physical custody
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Non-Adjudicated Children</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated24' id='chkAdjudicated24' className='add-only' value='1' />08 - Other DCF program status
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated23' id='chkAdjudicated23' className='add-only' value='1' />09 - Under custody & supervision of family/guardian
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Adults with No Court Jurisdiction:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated21' id='chkAdjudicated21' className='add-only' value='1' />10 - Competent, no charges
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated20' id='chkAdjudicated20' className='add-only' value='1' />11 - Civil incompetence of person or property
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Adults with Court Jurisdiction:<br />Criminal Competent</b></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated19' id='chkAdjudicated19' className='add-only' value='1' />12 - Incarcerated
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated18' id='chkAdjudicated18' className='add-only' value='1' />13 - Release pending hearing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated17' id='chkAdjudicated17' className='add-only' value='1' />14 - this code is no longer used
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated16' id='chkAdjudicated16' className='add-only' value='1' />15 - this code is no longer used
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated15' id='chkAdjudicated15' className='add-only' value='1' />16 - Release pending hearing ITP
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated14' id='chkAdjudicated14' className='add-only' value='1' />17 - Involuntarily hospitalized (direct commit)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated11' id='chkAdjudicated11' className='add-only' value='1' />20 - No longer used
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated10' id='chkAdjudicated10' className='add-only' value='1' />21 - Conditionally released
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated13' id='chkAdjudicated13' className='add-only' value='1' />18 - Incarcerated
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated12' id='chkAdjudicated12' className='add-only' value='1' />19 - Involuntarily hospitalized - revocation of conditional
                            release.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Not Guilty by Reason of Insanity (NGI):</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated7' id='chkAdjudicated7' className='add-only' value='1' />24 - Released pending hearing.
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated6' id='chkAdjudicated6' className='add-only' value='1' />25 - Conditionally released.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated5' id='chkAdjudicated5' className='add-only' value='1' />26 - Incarcerated.
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated4' id='chkAdjudicated4' className='add-only' value='1' />29 - Incompetent to proceed - Ages 21+
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated9' id='chkAdjudicated9' className='add-only' value='1' />22 - Involuntary hospital - direct commit.
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkAdjudicated8' id='chkAdjudicated8' className='add-only' value='1' />23 - Involuntary hospital - revocation of conditional
                            release.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Juvenile Incompetent to Proceed</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated3' id='chkAdjudicated3' className='add-only' value='1' />27 - Incompetent to Proceed - Ages 0 - 17
                        </td>
                        <td className='w-350'>
                            <input type='checkbox' name='chkAdjudicated2' id='chkAdjudicated2' className='add-only' value='1' />28 - Incompetent to Proceed - Ages 18 - 20
                        </td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='checkbox' name='chkAdjudicated1' id='chkAdjudicated1' className='add-only' value='1' />28 - Incompetent to Proceed - Age 21
                        </td>
                        <td className='w-350'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Pages 6B - 5 and 6</b>
                </p>
                <p className='w-750'>
                    <b>Drug list in Appendix 5</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>*SUBSTANCE PROBLEM</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>15. *Primary:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>16. Secondary:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>17. Tertiary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary' name='txtPrimary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary' name='txtSecondary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary' name='txtTertiary' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Page 6B - 6</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b>*USUAL ROUTE OF ADMINISTRATION</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>18. *Primary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute_Yes' name='rbUsualRoute' className='add-only' value='1' /> 1 - Oral
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute_Ys' name='rbUsualRoute' className='add-only' value='2' /> 2 - Smoking
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute_No' name='rbUsualRoute' className='add-only' value='3' /> 3 - Inhalation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute_Nu' name='rbUsualRoute' className='add-only' value='4' /> 4 - Injection
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbUsualRoute_Ni' name='rbUsualRoute' className='add-only' value='5' /> 5 - Other: &nbsp;
                            <input type='text' id='txtUsualRoute' name='txtUsualRoute' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>19. Secondary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute1_Yes' name='rbUsualRoute1' className='add-only' value='1' /> 1 - Oral
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute1_Ys' name='rbUsualRoute1' className='add-only' value='2' /> 2 - Smoking
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute1_No' name='rbUsualRoute1' className='add-only' value='3' /> 3 - Inhalation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute1_Nu' name='rbUsualRoute1' className='add-only' value='4' /> 4 - Injection
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbUsualRoute1_Ni' name='rbUsualRoute1' className='add-only' value='5' /> 5 - Other: &nbsp;
                            <input type='text' id='txtUsualRoute1' name='txtUsualRoute1' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>20. Tertiary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute2_Yes' name='rbUsualRoute2' className='add-only' value='1' /> 1 - Oral
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute2_Ys' name='rbUsualRoute2' className='add-only' value='2' /> 2 - Smoking
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute2_No' name='rbUsualRoute2' className='add-only' value='3' /> 3 - Inhalation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoute2_Nu' name='rbUsualRoute2' className='add-only' value='4' /> 4 - Injection
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbUsualRoute2_Ni' name='rbUsualRoute2' className='add-only' value='5' /> 5 - Other: &nbsp;
                            <input type='text' id='txtUsualRoute2' name='txtUsualRoute2' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>Page 6B - 6 and 7</b></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <b>*FREQUENCY OF USE (MONTH PRIOR TO EVALUATION)</b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>21. *Primary:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_Yes' name='rbUsualRoutePr' className='add-only' value='1' /> 1 - No past month use
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_Ys' name='rbUsualRoutePr' className='add-only' value='2' /> 4 - 3 to 6 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_No' name='rbUsualRoutePr' className='add-only' value='3' /> 2 - 1 to 3 times in past month
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_Nu' name='rbUsualRoutePr' className='add-only' value='4' /> 3 - 1 to 2 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr_Ni' name='rbUsualRoutePr' className='add-only' value='5' /> 5 - Daily
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>22. Secondary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_Yes' name='rbUsualRoutePr1' className='add-only' value='1' /> 1 - No past month use
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_Ys' name='rbUsualRoutePr1' className='add-only' value='2' /> 4 - 3 to 6 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_No' name='rbUsualRoutePr1' className='add-only' value='3' /> 2 - 1 to 3 times in past month
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_Nu' name='rbUsualRoutePr1' className='add-only' value='4' /> 3 - 1 to 2 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr1_Ni' name='rbUsualRoutePr1' className='add-only' value='5' /> 5 - Daily
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>23. Tertiary:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_Yes' name='rbUsualRoutePr2' className='add-only' value='1' /> 1 - No past month use
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_Ys' name='rbUsualRoutePr2' className='add-only' value='2' /> 4 - 3 to 6 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_No' name='rbUsualRoutePr2' className='add-only' value='3' /> 2 - 1 to 3 times in past month
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_Nu' name='rbUsualRoutePr2' className='add-only' value='4' /> 3 - 1 to 2 times per week
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbUsualRoutePr2_Ni' name='rbUsualRoutePr2' className='add-only' value='5' /> 5 - Daily
                        </td>
                    </tr>
                </table>


                <p className='w-750'><b>Page 6B - 7</b></p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <b>*AGE OF FIRST DRUG OR ALCOHOL USE</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>24. *Primary:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>25. Secondary:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>26. Tertiary:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary24' name='txtPrimary24' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary25' name='txtSecondary25' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary26' name='txtTertiary26' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><b>27. *STAFF ID:</b>&nbsp;<input type='text' id='txtStaffId' name='txtStaffId' className='add-only w-350 custom-add-only' /></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>28. *PURPOSE OF EVALUATION:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>29. EVALUATION DATE:</span>
                            <span className='small'>Discharge Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' name='chkPurpose' id='chkPurpose' className='add-only' value='1' />1 - Discharge &nbsp; &nbsp;
                            <input type='checkbox' name='chkPurpose1' id='chkPurpose1' className='add-only' value='1' />2 - Administrative Discharge
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtEvalDate' placeholder='Discharge Date' name='txtEvalDate' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>Questions 30 through 36 are Mandatory for clients who are under 18</b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>30. *CHILD PREVENTION</span>
                    <input type='radio' id='rbEnglish30_Yes' name='rbEnglish30' className='add-only' value='1' /> 0 - No &nbsp;
                    <input type='radio' id='rbEnglish30_No' name='rbEnglish30' className='add-only' value='2' /> 1 - Yes
                </p>
                
                <p className='w-750'>
                    <b>Page 6B - 8</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>31. *DRUGS HARMFUL:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkDrugsHar' id='chkDrugsHar' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkDrugsHar1' id='chkDrugsHar1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkDrugsHar2' id='chkDrugsHar2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>32. *ALCOHOL HARMFUL:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAlcoholHarm' id='chkAlcoholHarm' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAlcoholHarm1' id='chkAlcoholHarm1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkAlcoholHarm2' id='chkAlcoholHarm2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>33. *TOBACCO HARMFUL:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTabaccoHarm' id='chkTabaccoHarm' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTabaccoHarm1' id='chkTabaccoHarm1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTabaccoHarm2' id='chkTabaccoHarm2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>34. *TOBACCO USE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTabaccoUse' id='chkTabaccoUse' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTabaccoUse1' id='chkTabaccoUse1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkTabaccoUse2' id='chkTabaccoUse2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>35. *FUTURE USE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkFutureUse' id='chkFutureUse' className='add-only' value='1' />No past experimentation or use and no future intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkFutureUse2' id='chkFutureUse2' className='add-only' value='1' />No past experimentation or use but expresses future use
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkFutureUse3' id='chkFutureUse3' className='add-only' value='1' />Past experimentation or use but no further intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkFutureUse4' id='chkFutureUse4' className='add-only' value='1' />Past experimentation or use and expresses further intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkFutureUse5' id='chkFutureUse5' className='add-only' value='1' />Currently experiments or uses substance
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>36. *FRIENDS USE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkFriendUsw' id='chkFriendUsw' className='add-only' value='1' />0 - No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkFriendUsw1' id='chkFriendUsw1' className='add-only' value='1' />1 - Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkFriendUsw2' id='chkFriendUsw2' className='add-only' value='1' />3 - Unknown
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>37. *INITIAL EVALUATION DATE:</b> &nbsp;<input type='text' id='txtIniEvaulDate' name='txtIniEvaulDate' className='add-only w-350 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>38. *EMPLOYMENT:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment' id='chkEmployment' className='add-only' value='1' />10 - Active Military, Overseas
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment1' id='chkEmployment1' className='add-only' value='1' />70 - Terminated/Unemployed
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment2' id='chkEmployment2' className='add-only' value='1' />11 - Active Military, USA
                        </td>
                    </tr>
                    <tr>
                        <td className='w-550'>
                            <input type='checkbox' name='chkEmployment3' id='chkEmployment3' className='add-only' value='1' />81 - Homemaker (must keep house for 1 or more others)
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment4' id='chkEmployment4' className='add-only' value='1' />12 - Full Time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment5' id='chkEmployment5' className='add-only' value='1' />82 - Student
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment6' id='chkEmployment6' className='add-only' value='1' />31 - *Unpaid Family Worker
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment7' id='chkEmployment7' className='add-only' value='1' />83 - Disabled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment8' id='chkEmployment8' className='add-only' value='1' />40 - Part Time
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment9' id='chkEmployment9' className='add-only' value='1' />84 - Criminal Inmate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment11' id='chkEmployment11' className='add-only' value='1' />50 - Leave of Absence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment12' id='chkEmployment12' className='add-only' value='1' />85 - Inmate Other
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment13' id='chkEmployment13' className='add-only' value='1' />60 - Retired
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkEmployment14' id='chkEmployment14' className='add-only' value='1' />86 - Not Authorized to Work
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    *Note: Unpaid Family Worker - A family member who works at least 15 hours or more a week without pay in a family-
                    operated enterprise. If an individual refuses to work because they are making money through illegal activities (i.e., drug
                    sales or prostitution) the client should be coded as unemployed '70'.
                </p>
                <p className='w-750'>
                    <b>Page 6B - 9</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>39. *DISCHARGE REASON:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>40. *DISCHARGE PREGNANCY OUTCOME:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrimary39' name='txtPrimary39' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSecondary40' name='txtSecondary40' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>SERVICES PROVIDED/REFERRED FOR BLOCK GRANT REQUIREMENT - MANDATORY</b>
                </p>
                <p className='w-750'>
                    The following 23 items (41 - 62) indicate the services provided or referrals given within the admission and discharge dates.
                    This is not intended to be an all-inclusive listing of services.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Indicate the appropriate code below.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkServiceProve' id='chkServiceProve' className='add-only' value='1' />Agency Provided
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkServiceProve1' id='chkServiceProve1' className='add-only' value='1' />Referral Made
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkServiceProve2' id='chkServiceProve2' className='add-only' value='1' />Both Provided and Referred
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkServiceProve3' id='chkServiceProve3' className='add-only' value='1' />Not Applicable
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkServiceProve4' id='chkServiceProve4' className='add-only' value='1' />Unknown
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>41. *CHILD CARE SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>42. *CRIMINAL JUSTICE SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>43. *EDUCATION SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary41' name='txtPrimary41' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary42' name='txtSecondary42' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary43' name='txtTertiary43' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>44. *FAMILY SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>45. HIV SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>46. *HIV EDUCATION SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary44' name='txtPrimary44' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary45' name='txtSecondary45' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary46' name='txtTertiary46' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>47. *HIV EARLY INTERVENTION:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>48. *HIV TESTING SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrimary47' name='txtPrimary47' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtSecondary48' name='txtSecondary48' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><b>Page 6B - 10</b></p>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>49. *HOUSING SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>50. *IMMUNIZATION SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>51. *INTERIM SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary49' name='txtTertiary49' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary50' name='txtPrimary50' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary51' name='txtSecondary51' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>52. *MEDICAL SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>53. *MENTAL HEALTH SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>54. *PEDIATRIC SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary52' name='txtTertiary52' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary53' name='txtPrimary53' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary54' name='txtSecondary54' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>55. *PRENATAL SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>59. *TRANSPORTATION SERVICES:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>60. *TREATMENT PLAN SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary55' name='txtTertiary55' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary59' name='txtPrimary59' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary60' name='txtSecondary60' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>61. *TRAINING SERVICES:</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>56. *PUBLIC ASSISTANCE ELIGIBILTY:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary61' name='txtTertiary61' className='add-only' />
                        </td>
                        <td className='w-500'>
                            <input type='text' id='txtPrimary56' name='txtPrimary56' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>57. *PUBLIC ASSISTANCE SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtSecondary57' name='txtSecondary57' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>58. *TUBERCULOSIS TESTED SERVICES:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtTertiary581' name='txtTertiary581' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><b>Page 6B - 11</b></p>

                <p className='w-750'>
                    <b>2. VOCATIONAL TRAINING SERVICES:</b>&nbsp;<input type='text' id='txtTertiary58' name='txtTertiary58' className='add-only w-350 custom-add-only' />
                </p>

                <p className='w-750'>
                    <b>SURVEY:</b> Survey is no longer collected, must be space filled for the 613 characters starting at
                    position 128 and ending with 740.
                </p>

                <p className='w-750'>
                    <b>64. PROVIDER INFORMATION:</b>&nbsp;
                    <input type='text' id='txtTertiary64' name='txtTertiary64' className='add-only w-350 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>65. *DRUG FREE STATUS:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkDrugFreeStatus' id='chkDrugFreeStatus' className='add-only' value='1' />No
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkDrugFreeStatus2' id='chkDrugFreeStatus2' className='add-only' value='1' />Yes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkDrugFreeStatus3' id='chkDrugFreeStatus3' className='add-only' value='1' />Unknown
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkDrugFreeStatus4' id='chkDrugFreeStatus4' className='add-only' value='1' />not applicable
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>66. *PROVIDER ID:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>67. SADIAG:</span><span className='small'>Must be space filled</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>68. MHDIAG.</span><span className='small'>Must be space filled</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPrimary591' name='txtPrimary591' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSecondary601' name='txtSecondary601' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtTertiary611' name='txtTertiary611' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>69. ARREST_ MUST be space filled</b><br />
                    A new Arrest field is listed below which is now a 2-digit field: &nbsp;<input type='text' id='txtArrest' name='txtArrest' className='add-only w-250 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>70. *CONTACT NUMBER 1:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>71. CONTACT NUMBER 2:</span><span className='small'>(No longer used - must be space filled)</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>72. CONTACT NUMBER 3:</span><span className='small'>(No longer used - must be space filled)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtContactNumber' name='txtContactNumber' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactNumber1' name='txtContactNumber1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactNumber2' name='txtContactNumber2' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>73. *SOCIAL CONNECTEDNESS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialConnected2' id='chkSocialConnected2' className='add-only' value='1' />02 - 1-3 times in past month
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialConnected3' id='chkSocialConnected3' className='add-only' value='1' />03 - 4-7 times in past month
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialConnected4' id='chkSocialConnected4' className='add-only' value='1' />04 - 8-15 times in past month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialConnected5' id='chkSocialConnected5' className='add-only' value='1' />05 - 16-30 times in past month
                        </td>
                        <td className='w-500'>
                            <input type='checkbox' name='chkSocialConnected' id='chkSocialConnected' className='add-only' value='1' />01 - No attendance in the past month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' name='chkSocialConnected6' id='chkSocialConnected6' className='add-only' value='1' />06 - Some attendance in past month, frequency unknown
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>


                <p className='w-750'><b>Page 6B - 12</b></p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>74. *SCHOOL ATTENDANCE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialAttendence' id='chkSocialAttendence' className='add-only' value='1' />1 - Suspended
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialAttendence2' id='chkSocialAttendence2' className='add-only' value='1' />2 - Expelled
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialAttendence3' id='chkSocialAttendence3' className='add-only' value='1' />3 - Suspended and Expelled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' name='chkSocialAttendence4' id='chkSocialAttendence44' className='add-only' value='1' />4 - Not Applicable
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>75. *ARREST:</b> Number of arrests in the last 30 days: &nbsp;<input type='text' id='txtFamilySize72' name='txtFamilySize72' className='add-only w-350 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>76. *SADIAG10:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>77. MHDIAG10:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtContactNumber73' name='txtContactNumber73' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtContactNumber74' name='txtContactNumber74' className='add-only' />
                        </td>
                    </tr>
                </table>

            </div>
        </form>

    )
}

